<template>
  <div id="TextAreaQuestion">
    <div class="dmh-confirm-container w-100">
      <textarea
        v-model="answerText"
        @input="filterInput"
        class="dmh-confirm-input"
        rows="4"
        maxlength="300"
        placeholder="Enter text here"
      />
    </div>
    <div class="bottom-content">
      <span class="label">Minimum 5 characters required</span>
      <span>{{ answerText.length }}/300</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "TextAreaQuestion",
  props: ["question", "answer", "setAnswer"],
  data() {
    return {
      answerText: this.answer || ""
    };
  },
  methods: {
    filterInput(event) {
      const cleanValue = event.target.value.replace(/[^a-zA-Z0-9 .,@!?'()]/g, '');
      this.answerText = cleanValue;
    }
  },
  watch: {
    answer(newAnswer) {
      this.answerText = newAnswer || "";
    },
    answerText(newText) {
      this.setAnswer(newText, this.question);
    }
  }
};
</script>
<style lang="less">
#TextAreaQuestion {
  .dmh-confirm-container {
    display: flex;
    flex-direction: column;
    font-size: 1.6rem;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #aeb0bd;
    padding: 15px;
    margin-bottom: 20px;

    .label {
      color: #1e1e22;
    }

    .dmh-confirm-input {
      font-family: var(--font-regular, "DMSans");
      font-size: 1.6rem;
    }

    textarea {
      background: #ffffff;
      border: none;
      width: 100%;
    }

    textarea:focus {
      outline-width: 0;
    }
  }

  .bottom-content {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    align-items: center;
    font-size: 1.6rem;
    font-family: var(--font-regular, "DMSans");
  }

  .dmh-confirm-container:focus-within {
    border-color: #1e1e22 !important;
  }
}
</style>
